import { css } from "styled-components";

export const reset = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  button {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: top;
    outline: 0;
    -webkit-appearance: none;
    background: none;
  }

  button {
    font-size: 1.5rem;
  }

  .g-recaptcha {
    margin: 15px auto;
    max-width: 70%;
    display: inline-block;
  }
  input,
  textarea {
    border: 0;
  }

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    height: 100%;
    overflow: hidden;
    vertical-align: top;
  }
  html,
  body {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  span.clear {
    display: block;
    clear: both;
  }
  p.clear,
  span.clear {
    display: block;
    clear: both;
    text-align: justify;
    padding: 4px 8px 4px 4px;
  }

  span.readMore,
  button.readMore.hidden {
    display: none;
  }

  span.readMore.visible,
  button.readMore.visible {
    display: block;
    float: right;
  }

  button.readMore:hover,
  button.readLess:hover {
    opacity: 0.8;
  }

  span.pBreak {
    display: block;
    margin-top: 10px;
    height: 1px;
  }

  h3 {
    letter-spacing: 0.6px;
    padding-top: 10px;
    font-weight: bold;
  }
  ul,
  ol {
    text-align: left;
    margin-left: 40px;
  }
  table {
    border-collapse: collapse;
    width: 90%;
    margin: 15px auto;
  }

  table,
  tr {
    border: 1px solid ${props => props.theme.themeGlobal.bgLight};
  }
  tr.tableTitle {
    background: ${props => props.theme.themeGlobal.bgLight};
    font-weight: bold;
    text-align: left;
  }
  td {
    padding: 3px 10px;
    vertical-align: middle;
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${props => props.theme.themeGlobal.headingColor};
  }

  @media only screen and (min-width: 991.98px) {
    button {
      cursor: pointer;
    }
    button:hover {
      opacity: 0.8;
    }
  }
`;

const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "600px",
  laptop: "1024px",
  laptopL: "1440px",
  large: "2560px"
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet}) and (orientation: portrait)`,
  laptop: `(min-width: ${size.laptop}) and (min-height: 600px)`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktopL: `(min-width: ${size.desktop})`,
  large: `(min-width: ${size.large})`,
  landscape: `(min-width: ${size.mobileS}) and (max-width: 998px) and (orientation: landscape)`
};
